export default {
    select: "Selecione o endereço de entrega",
    shippingRulesTip: "Você tem que seguir as regras locais para envio"
}